import { render, staticRenderFns } from "./ClientBtn.vue?vue&type=template&id=69b06d8b&"
import script from "./ClientBtn.vue?vue&type=script&lang=js&"
export * from "./ClientBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports